The page of webhook subscriptions and their corresponding cursors.
